
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";

import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { Grid } from "@/components/Grid";
import { BlogText } from "@/components/BlogText";
import { CTASection } from "@/sections/CTASection";
import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";

const ImportFigmaInCanva = () => {
  const { colors } = useTheme();
  return (
    <>
      <Head
        pageNamespace="page/import-figma-in-canva"
        ogImage="/images/main-og-image.jpg"
      />

      <div>
        <Grid
          customStyle={{
            maxWidth: 800,
            flexDirection: "column",
            alignItems: "flex-start",
            paddingBottom: "0 !important",
          }}
        >
          <Heading as="h1">
            Import Figma designs in Canva using our Canva Plugin
          </Heading>
          <BlogText>
            It's been a while since we've released a new product, but it's
            finally here. You can now use our Figma to Canva converter to import
            and convert Figma design directly into Canva.
          </BlogText>
          <BlogText>
            The process of converting your Figma designs is very straight
            forward. In this tutorial we will go over the process step-by-step.
            You'll see how easy it is to import your Figma designs and directly
            use them in Canva.
          </BlogText>
          <BlogText>So let's get started</BlogText>

          <section>
            <Heading as="h2">Install our Figma to Canva Plugin</Heading>
            <ol>
              <li>
                <BlogText>
                  <strong>
                    Before you get started make sure you're logged into your
                    Canva account
                  </strong>
                  <br />
                  Head over to{" "}
                  <a
                    href="https://canva.com/login"
                    style={{
                      color: colors.RED,
                      fontWeight: "bold",
                    }}
                  >
                    Canva.com
                  </a>{" "}
                  and log into your account.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/canva-login.jpg"
                  alt="Canva Login Screen"
                />
              </li>
              <li>
                <BlogText>
                  <strong>Install the App from the Canva App Store</strong>
                  <br />
                  Head over the Canva App Marketplace and search for "Figma to
                  Canva". You'll see our Figma to Canva Converter. Alternatively
                  you can access the plugin directly using this link:{" "}
                  <a
                    href="https://www.canva.com/your-apps/AAFyRw9Uc8o"
                    style={{
                      color: colors.RED,
                      fontWeight: "bold",
                    }}
                  >
                    Figma to Canva - Canva App Store
                  </a>
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/install-figma-to-canva-app.jpg"
                  alt="Install Magicul Figma to Canva Converter"
                />
                <BlogText>
                  Simply click on "Use in new design" and then insert the size
                  of the design in Figma that you'd like to import into Canva.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/figma-to-canva-set-size.jpg"
                  alt="Set Size of Canva Design"
                />
              </li>
              <li>
                <BlogText>
                  <strong>The Plugin is now installed</strong>
                  <br />
                  Confirm this by clicking on "Create new design". As you can
                  see now the plugin is install and you're ready to import your
                  Figma design into Canva.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/figma-to-canva-app-installed.jpg"
                  alt="Figma to Canva App Installed"
                />
              </li>
            </ol>
          </section>
          <section>
            <Heading as="h3">Importing from Figma to Canva</Heading>
            <ol>
              <li>
                <BlogText>
                  Open your Figma design that you want to import in Canva.
                </BlogText>
              </li>
              <li>
                <BlogText>
                  Make sure that the Figma frame that you're trying to import
                  has the exact same size as the Canva design you want to import
                  it to. In our case that is 1800x900 pixels.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/figma-example-banner.jpg"
                  alt="Figma Example Banner for Canva"
                />
              </li>
              <li>
                <BlogText>
                  Copy the link to the exact Figma Frame. To this right click on
                  the frame title on the Figma canvas. The select "Copy/Paste
                  as" and then "Copy Link". <b>NOTE: </b>It's important that you
                  only copy the link to a particular Figma frame, you can't
                  import an entire Figma design.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/copy-link-figma-frame.jpg"
                  alt="Copy Link to Figma Frame"
                />
              </li>
              <li>
                <BlogText>
                  Insert Link into Magicul Figma to Canva Plugin
                  <br />
                  It as easy as that. Simply paste the link into our Figma to
                  Canva plugin and you're ready to start.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/import-figma-in-canva/insert-figma-frame-link.jpg"
                  alt="Insert Figma frame link in plugin"
                />
              </li>
            </ol>
            <BlogText>
              Hit the "Convert" button and you'll slowly see your content appear
              in Canva.
            </BlogText>
            <Image
              customStyle={{ width: "100%", marginBottom: 29 }}
              src="/images/tutorials/import-figma-in-canva/figma-importer-canva.jpg"
              alt="Figma content imported in Canva"
            />
            <CTASection
              title="Want to import your Figma designs in Canva?"
              buttonLabel="Start Now"
              href="/converter/figma-to-canva"
            />
          </section>
        </Grid>
      </div>
    </>
  );
};

export default ImportFigmaInCanva;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/tutorials/import-figma-in-canva-using-plugin',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  